module.exports = __webpack_public_path__ + "img/3x.572bd2f.jpg";